import { verifyMemberEmailAsync } from 'api/registration';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import FormContainer from './common/FormContainer';
import AccountSetup from './pages/AccountSetup';
import Confirmation from './pages/Confirmation';
import EmailVerification from './pages/EmailVerification';
import MemberVerification from './pages/MemberVerification';
import './Registration.scss';
enum STEPS {
    VERIFICATION,
    ACCOUNT_SETUP,
    EMAIL_VERIFICATION,
    CONFIRMATION,
}

const RegistrationForm = () => {
    const { createToken } = useParams();
    const [formState, setFormState] = useState({ page: STEPS.VERIFICATION });
    const [loading, setLoading] = useState(false);
    const authorizeAccountAccess = (token: string) => {
        setLoading(true);
        verifyMemberEmailAsync(token)
            .then(({ isSuccess }) => {
                setFormState((prevState) => ({
                    ...prevState,
                    success: isSuccess,
                    page: STEPS.CONFIRMATION,
                }));
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                setFormState((prevState) => ({
                    page: STEPS.VERIFICATION,
                }));
            });
    };
    useEffect(() => {
        createToken && authorizeAccountAccess(createToken);
    }, [createToken]);
    const CurrentPage = ({ ...rest }) => {
        switch (formState.page) {
            case STEPS.VERIFICATION:
                return (
                    <MemberVerification
                        onComplete={(data) =>
                            setFormState((prevState) => ({
                                ...data,
                                ...prevState,
                                page: STEPS.ACCOUNT_SETUP,
                            }))
                        }
                        {...rest}
                    />
                );
            case STEPS.ACCOUNT_SETUP:
                return (
                    <AccountSetup
                        onComplete={(data) =>
                            setFormState((prevState) => ({
                                ...data,
                                ...prevState,
                                page: STEPS.EMAIL_VERIFICATION,
                            }))
                        }
                        onBack={() =>
                            setFormState((prevState) => ({
                                ...prevState,
                                page: STEPS.VERIFICATION,
                            }))
                        }
                        {...rest}
                    />
                );
            case STEPS.EMAIL_VERIFICATION:
                return <EmailVerification {...rest} />;
            case STEPS.CONFIRMATION:
                return <Confirmation {...rest} />;
            default:
                return null;
        }
    };
    return (
        <div id="wizard-container">
            <FormContainer>
                {loading ? (
                    <Spinner color="secondary" />
                ) : (
                    <CurrentPage state={formState} />
                )}
            </FormContainer>
        </div>
    );
};
export default RegistrationForm;
